﻿import { RadioGroupProps } from '@progress/kendo-react-inputs';
import clsx from 'clsx';
import './SegmentedControl.css';

export interface SegmentedControlProps extends RadioGroupProps {
    indicators?: Record<string | number, number>; // optional indicators to show on each segment
    prefixes?: Record<string | number, React.ReactNode>; // optional prefixes to show on each segment
}

export default function SegmentedControl(props: SegmentedControlProps) {
    return (
        <div className="d-inline-block">
            <div style={props.style} className={clsx('cobalt-segmented-control d-flex align-items-center', props.className)}>
                {props.data?.map((b) => (
                    <div
                        className={clsx(
                            'cobalt-segmented-item cursor-pointer d-flex gap-1 align-items-center',
                            props.disabled && 'pe-none'
                        )}
                        key={b.value}
                        aria-disabled={props.disabled}
                        aria-pressed={b.value === props.value}
                        data-checked={b.value === props.value}
                        onClick={(e) => {
                            props.onChange?.({ ...e, value: b.value } as any);
                        }}>
                        {props.prefixes && props.prefixes[b.value] && <span className="me-1">{props.prefixes[b.value]}</span>}
                        <span>{b.label}</span>
                        {props.indicators && props.indicators[b.value] !== undefined && (
                            <span className="fe-badge p-1 py-0">{props.indicators[b.value]}</span>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
